import { Component } from "@angular/core";
import { UserModel, UserFilterModel,UserService, ChangePasswordModal,ChangePasswordByAdmin } from "@bt/core";
import * as $ from 'jquery';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from 'angular-notifier';
import { NgbModal,NgbActiveModal,NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {DeleteUserModalContent  } from './delete-users-modal/delete-users.modal';
import { Router } from "@angular/router";
import { ChangePasswordModalContent } from "./change-password-modal";
import {faUserPlus,faUserTimes, faUnlock, faLock, faSearch} from "@fortawesome/free-solid-svg-icons"

@Component({
  selector: "app-all-users",
  templateUrl: "./all-users.component.html",
  styleUrls: ["./all-users.component.scss"]
})
export class AllUsersComponent extends BaseComponent {
  faUserPlus=faUserPlus;
  faUserTimes=faUserTimes;
  faUnlock = faUnlock;
  faLock = faLock;
  faSearch = faSearch;

  public defaultDate:any;
  public usersList: UserModel[];
  public userFilter: UserFilterModel;
  public totalUsersCount: number;
  public totalAdminCount: number;
  public activeUsersCount: number;
  private notifier: NotifierService;
  public currentUserRole: number;
  private currentUserId: string;
  public isResponsed: boolean = false;
  public roleList: any[];
  public roleListForSuperAdmin: any[];
  public statusList: any[];
  public organizationFilterOptions: any = [];
  public config: any;

  private isSmthChecked = false;
  public modalRef: NgbModalRef;
  public quantity: number;
  public listener:any;
  levelStatusOptions : any;
  public hasInfo:boolean = false;


  ngOnDestroy() {
    try{
    var body = document.getElementById("my-all-users");
    body.addEventListener('click', this.listener, false);
    }catch{}
  }
  constructor(
    private router: Router,
    private userService: UserService,
    notifierService: NotifierService,private modalService: NgbModal
  ) {
    super();
    this.notifier = notifierService;
    this.quantity = 0;
    this.usersList = [];
    this.userFilter = new UserFilterModel();
    this.roleList = [
     // { value: -2, label: "Роль пользователя" }, //дефолтное значение, для совпадания плейсхолдера с макетом
      { value: -1, label: "Все роли" },
      { value: 0, label: "Пользователь" },
      { value: 1, label: "Администратор" },
    ];
    this.roleListForSuperAdmin = [
      // { value: -2, label: "Роль пользователя" }, //дефолтное значение, для совпадания плейсхолдера с макетом
       { value: -1, label: "Все роли" },
       { value: 0, label: "Пользователь" },
       { value: 1, label: "Администратор" },
       { value: 2, label: "Суперадминистратор" }
     ];
    this.statusList = [
     // { value: -2, label: "Статус" }, //дефолтное значение, для совпадания плейсхолдера с макетом
      { value: -1, label: "Все статусы" },
      { value: 0, label: "Новый" },
      { value: 10, label: "Активный" },
      { value: 20, label: "Заблокированный" }
    ];

    
    this.userFilter.role = -1;
    this.userFilter.status = -1;
    this.userFilter.levelStatus = -1;
    this.userFilter.RegistrationDateEnd = null;
    this.userFilter.RegistrationDateStart = null;
    this.userFilter.LastActivityDateEnd = null;
    this.userFilter.LastActivityDateStart = null;

    this.currentUserRole = this.userService.getRole();
    this.currentUserId = this.userService.getId();

    this.config = {
      labelField: 'label',
      valueField: 'value',
      searchField: 'label',
      highlight: false,
      create:false,
      persist:true,
      //plugins: ['dropdown_direction', 'remove_button'],
      dropdownDirection: 'down',
      maxItems: 1
    };

    

   let t =this;
    $(document).ready(function () {
      var container = $('.container');
      var topscroll = $('#topscroll');

      $('.fake').width($('#theTable').width());

      topscroll.scroll(function(e){
        container.scrollLeft($(this).scrollLeft());
      });
      container.scroll(function(e){
        topscroll.scrollLeft($(this).scrollLeft());
       });
      var body = document.getElementById("my-all-users");
      var listener = function (event) {
        if($("app-all-users").val()!=undefined) 
        {
          if((event.target.children.length==0  || event.target.children[0].className!="myImg" ) 
          &&( event.target.classList.length==0 || !event.target.classList.contains("myImg"))){
            for(let i=0;i<t.usersList.length;i++){
              $("#action-panel" + i).addClass('hidden');
              $("#mob-action-panel" + i).addClass('hidden');
            }
          }
        }
        else{
          body.removeEventListener('click', listener, false);
        }
      };
      body.addEventListener('click', listener, false);
    });

  }

  //начинают выполнятся методы при открытии страницы
  public ngOnInit() {
    this.loadTotalUsers();
    this.loadUsers();

  }

  //получение кол-ва пользователей
  public loadTotalUsers() {
    if (this.currentUserRole==2){
      this.userService.getAllNumberOfUsersForSuperAdmin()
      .then((resp) => {
        this.totalUsersCount = resp.data[0];
        this.totalAdminCount = resp.data[1];
        this.activeUsersCount = resp.data[2];
      })
      .catch((error) => {
        console.error(error.error);
      });
    }
    else{
    this.userService.getAllNumberOfUsers()
      .then((resp) => {
        this.totalUsersCount = resp.data[0];
        this.totalAdminCount = resp.data[1];
        this.activeUsersCount = resp.data[2];
      })
      .catch((error) => {
        console.error(error.error);
      });
    }
  }


  public loadUsers() { //метод для обращения к сервису
    var t = this;
    t.setLoading(true);

    /////////////////////костыль для того что бы время на бек приходило без смещения на 3 часа
    if(t.userFilter.RegistrationDateStart!=null){
      try{
          t.userFilter.RegistrationDateStart=(<any>t).userFilter.RegistrationDateStart.toDateString();
        
      }
      catch{
        t.userFilter.RegistrationDateStart=null;
        t.setLoading(false);
        t.loadUsers();
      }
     
    }
    
   
    if(t.userFilter.RegistrationDateEnd!=null)
      t.userFilter.RegistrationDateEnd=(<any>t).userFilter.RegistrationDateEnd.toDateString();
    if(t.userFilter.LastActivityDateStart!=null)
      t.userFilter.LastActivityDateStart=(<any>t).userFilter.LastActivityDateStart.toDateString();
    if(t.userFilter.LastActivityDateEnd!=null)
      t.userFilter.LastActivityDateEnd=(<any>t).userFilter.LastActivityDateEnd.toDateString();
    /////////////////////////
    
    this.userService.getAllUsers(this.userFilter)
      .then((resp) => {
        this.hasInfo = resp.data.length != 0;
        this.usersList = resp.data;     
        this.loadTotalUsers();
        t.setLoading(false);
        this.isResponsed = true;
      })
      .catch((error) => {
        this.hasInfo = false;
        console.error(error.error);
        t.setLoading(false);
            this.isResponsed = true;
      });
  }


  
  public toggleBlocked(user: UserModel) {

    var newStatus;

    if (user.status == 10) {
      newStatus = 20; // Blocked
    }
    else if (user.status == 20) {
      newStatus = 10; // Active
    }
    else if (user.status == 0) {
      newStatus = 20; // Blocked
    }
    else {
      return;
    }

    var t = this;
   
    this.setLoading(true);
    this.userService.setUserStatus(user.id, newStatus)
      .then((resp) => {
        if (resp.data == true) {
          this.loadUsers();

          if (newStatus == 20) {
            t.notifier.notify('error', 'Пользователь заблокирован');
          }
          else if (newStatus == 10) {
            t.notifier.notify('success', 'Пользователь разблокирован');
          }
        }
      })
      .catch((error) => {
        console.error(error.error);
      });

  }

  public toggleActionPanel(index: number) {
    for(let i=0;i<this.usersList.length;i++){
      if(i!=index)
      {
        $("#action-panel" + i).addClass('hidden');
        $("#mob-action-panel" + i).addClass('hidden');
      }
    }
    var panel = $("#action-panel" + index);
    if(panel.hasClass('hidden')){
      $("#action-panel" + index).removeClass('hidden');
    }
    else {
      $("#action-panel" + index).addClass('hidden');
    }

    var panel = $("#mob-action-panel" + index);
    if(panel.hasClass('hidden')){
      $("#mob-action-panel" + index).removeClass('hidden');
    }
    else {
      $("#mob-action-panel" + index).addClass('hidden');
    }
  }


  // public DeleteUsers() {

  //   Swal.fire({
  //    // title: 'Вы уверены?',
  //    // text: "Выбранные пользователи будут удалены!",
  //     //type: 'warning',
  //    html:
  //   `<div>
  //   <br>
  //   <h4 style="float: left;font-size: 20.0px;font-weight: 500;
  //   color: rgba(6,44,80,1.0);
  //   text-align: left;
  //   line-height: 24.0px;">Удаление</h4> <div class="swal2-icon swal2-warning swal2-animate-warning-icon" style="font-weight: 400;
  //   float: left;
  //   height: 21px;
  //   display: flex;
  //   border-color: red;
  //   color: red;
  //   width: 21px;
  //   font-size: 6px;
  //   margin: 0;
  //   bottom: -2px;
  //   left: 10px;"></div>
  //   <br>
  //   <br>
  //   <p style="float: left;
  //   font-family: 'Helvetica',Helvetica,Arial,serif;
  //   font-size: 12.0px;
  //   color: rgba(6,44,80,1.0);
  //   text-align: left;
  //   line-height: 19.0px;">Вы действительно хотите безвозвратно удалить выбранных пользователей?</p>
  //   </div>`,
  //     showCloseButton: true,
  //     showCancelButton: false,
  //     confirmButtonColor: 'white',//'#1f8efa',
  //     confirmButtonClass:'swal-superButton',
  //     // cancelButtonColor: '#d33',
  //     // cancelButtonText: 'Отмена',
  //     confirmButtonText: 'Удалить',
  //     focusConfirm: false,
  //     customClass:'swal-wide',
      
      
  //   }).then((result) => {
  //     if (result.value) {
  //       this.userService.deleteUsers(this.usersList)
  //         .then((resp) => {
  //           if (resp.data == true) {
  //             this.loadUsers();
  //           }
  //         })
  //         .catch((error) => {
  //           console.error(error.error);
  //         });
  //     }
  //   })
  // }

  public openDeleteUsers(){
    let t=this;
    t.modalRef = t.modalService.open(DeleteUserModalContent, 
      {
        backdropClass: 'light-white-backdrop', 
        centered: true , 
        size: 'sm',
        windowClass:'super-modal-delete-users very-nice-shadow',
        
      });
      t.modalRef.componentInstance.isNeedDelete=false;
      t.modalRef.componentInstance.description="Вы хотите удалить выбранных пользователей?";
      t.modalRef
      .result.then((result)=>{
        if(result){
          this.userService.deleteUsers(this.usersList)
          .then((resp) => {
            if (resp.data == true) {
              this.loadUsers();
              if(this.quantity == 1){
                this.notifier.notify('success', "Пользователь успешно удален");
                this.quantity = 0;
                }
                if(this.quantity > 1){
                  this.notifier.notify('success', "Пользователи успешно удалены");
                this.quantity = 0;
                }
            }
          })
          .catch((error) => {
            this.notifier.notify('error',error.error.errorMsgs[0]);
          });
        }
        this.usersList.forEach(user => {
          if (user.isDeleted == true)
          {
            this.quantity ++;
          }
        });
     
      },
      (reason) => {
        //если отменили нажали на крестик или мимо окна
      })
  }

  public showChangePasswordForm(user: UserModel) {
    let t=this;
    t.modalRef = t.modalService.open(ChangePasswordModalContent, 
      {
        backdropClass: 'light-white-backdrop', 
        centered: true , 
        // size: 'sm',
        windowClass:'super-modal-change-user',
        
      });
      // passing data to modal
      t.modalRef.componentInstance.user = user;
      t.modalRef.result
      .then((result)=>{
        if(!!result && result.needChange){
          var model: ChangePasswordByAdmin = {
            userId: user.id,
            newPassword: result.newPassword,
            newPasswordConf: result.newPasswordConf,
            needSendToEmail: result.needSendToEmail
          }
          this.uncheckUsers();
          this.userService.changePasswordByAdmin(model)
          .then((resp) => {
            this.notifier.notify('success', "Новый пароль успешно установлен");
          })
          .catch((error) => {
            console.error(error.error);
          });
        }
      },
      (reason) => {
        //если отменили нажали на крестик или мимо окна
      })
  }

  public uncheckUsers() {
    this.usersList.forEach(user => {
      user.isDeleted = false;
    });
  }

  public deleteUser(user: UserModel) {
    let t=this;
    t.modalRef = t.modalService.open(DeleteUserModalContent, 
      {
        backdropClass: 'light-white-backdrop', 
        centered: true , 
        size: 'sm',
        windowClass:'super-modal-delete-users',
      });
      t.modalRef.componentInstance.isNeedDelete=false;
      t.modalRef.componentInstance.description="Вы хотите удалить данного пользователя?";
      t.modalRef
      .result.then((result)=>{
        if(result){

          var userArr: UserModel[] = [];
          userArr[0] = user;

          this.userService.deleteUsers(userArr)
          .then((resp) => {
            if (resp.data == true) {
              this.loadUsers();
            }
          })
          .catch((error) => {
        //console.error(error.error);
          });
        }
        this.usersList.forEach(user => {
          if (user.isDeleted == true)
          {
            this.quantity ++;
          }
        });
        if(this.quantity == 1){
        this.notifier.notify('success', "Пользователь успешно удален");
        this.quantity = 0;
        }
      });
  }

  public isChecked()
  {
    this.isSmthChecked = false;
    this.usersList.forEach(user => {
      if (user.isDeleted == true)
      {
        this.isSmthChecked = true;
      }
    });

    return this.isSmthChecked;
  }

  public goToUsersProfile(id:string){
    this.router.navigateByUrl('users-profile/' + id);
  }

}


// WEBPACK FOOTER //
// ./src/app/admin/all-users/all-users.component.ts